import type { OrderItem } from "@jti/magento";

export const categorizeItems = (items: OrderItem[]) => {
  const standardItems: OrderItem[] = [];
  const subscriptionItems: OrderItem[] = [];

  items.forEach((item: OrderItem) => {
    if (item.subscription === 1) {
      subscriptionItems.push(item);
    } else {
      standardItems.push(item);
    }
  });

  return { standardItems, subscriptionItems };
};
